export const organizationalTree = [{
  prop: 'name',
  label: '姓名'
},
  {
    prop: 'gender',
    label: '性别',
    formatter: row => {
      return row === 1 ? '男' : (row === 2 ? '女' : '')
    }
  },
  {
    prop: 'mobile',
    label: '手机号',
    width: 110
  },
  // {prop:'wxWork',label:'企业微信'},
  {
    prop: 'job',
    label: '岗位'
  },
  {
    prop: 'jobRank',
    label: '岗位等级',
    width: 120
  },
  {
    prop: 'directOrganizationVOList',
    label: '隶属部门',
    formatter: row => {
      return row ? row.map(item => item.name).join('/') : ''
    },
    width: 100
  },
  {
    prop: 'ability',
    label: '能力系数'
  },
  {
    prop: 'fulltimeProjects',
    label: '专职项目数',
    width: 100
  },
  {
    prop: 'parttimeProjects',
    label: '兼职项目数',
    width: 100
  },
  {
    prop: 'tag',
    label: '标签'
  },
  {
    prop: 'resumeAttachment',
    label: '简历'
  },
  {
    prop: 'projectExperience',
    label: '项目经历'
  },
  {
    prop: 'workStatus',
    label: '状态'
  },
  {
    prop: 'needWriteReportFlag',
    label: '是否需要填写日报',
    formatter: row => {
      return row === 1 ? '√' : '';
    }
  },
  {
    prop: 'reportRemindFlag',
    label: '是否推送日报/周报提醒',
    formatter: row => {
      return row === 1 ? '√' : ''
    }
  }
]

export const demandTree = [

  {
    prop: 'name',
    label: '需求标题'
  },
  {
    prop: 'id',
    label: 'id',
    width: 100
  },
  {
    prop: 'date',
    label: '日期'
  },
  {
    prop: 'address',
    label: '地址'
  },
]

export const changeManageName = [

  {
    prop: 'name',
    label: '变更名称'
  },
  {
    prop: 'createTime',
    label: '创建时间'
  },
  {
    prop: 'docName',
    label: '变更文档'
  },
  {
    prop: 'demands',
    label: '变更所涉及需求'
  },
]

export const checkChangeManageName = [{
  prop: 'createTime',
  label: '创建时间'
},
  {
    prop: 'priority',
    label: '优先级'
  },
  {
    prop: 'name',
    label: '需求名称'
  },
  {
    prop: 'directModulePath',
    label: '所属模块'
  },
  {
    prop: 'changeFlag',
    label: '变更标记',
    formatter: row => {
      return row === 1 ? '原始' : (row === 2 ? '变更' : '暂无信息')
    }
  },
  {
    prop: 'planStartTime',
    label: '预计开始时间'
  },
  {
    prop: 'planEndTime',
    label: '预计结束时间'
  },
  {
    prop: 'status',
    label: '状态'
  },
]

export const progressName = [{
  prop: 'time',
  label: '项目时间'
},
  {
    prop: 'memberResourceRate',
    label: '人力比(%)'
  },
  {
    prop: 'finishedFeatureDemandsRate',
    label: '功能进度比(%)'
  },
  {
    prop: 'finishedTestDemandsRate',
    label: '测试进度比(%)'
  },
  {
    prop: 'predictProgressRate',
    label: '预估进度比(%)'
  }
]

export const auditItemsName = [{
  prop: 'employeeName',
  label: '用户'
},
  {
    prop: 'jobName',
    label: '岗位'
  },
  {
    prop: 'jobRankName',
    label: '等级'
  },
  {
    prop: 'intimacy',
    label: '专职/兼职',
    formatter: row => {
      return row === 1 ? '专职' : (row === 2 ? '兼职' : '暂无信息')
    }
  },
  {
    prop: 'fulltimeProjects',
    label: '专职项目'
  },
  {
    prop: 'parttimeProjects',
    label: '兼职项目'
  },
  {
    prop: 'projectName',
    label: '预加入项目'
  },
  {
    prop: 'status',
    label: '审批状态',
    formatter: row => {
      return row === 1 ? '已同意' : (row === 2 ? '已拒绝' : (row === 3 ? '待审核' : '已审批'))
    }
  },
  {
    prop: 'createByName',
    label: '申请人'
  },
  {
    prop: 'rejectReason',
    label: '驳回原因'
  }
]

export const workSpaceName = [{
  prop: 'name',
  label: '需求名称'
},
  {
    prop: 'jobName',
    label: '工作类型',
    sortable: 'custom'
  },
  {
    prop: 'createTime',
    label: '创建日期',
    sortable: 'custom'
  },
  {
    prop: 'priority',
    label: '优先级',
    sortable: 'custom',
    width: 100
  },
  {
    prop: 'projectVersionName',
    label: '所属版本'
  },
  {
    prop: 'planStartTime',
    label: '预计开始时间',
    sortable: 'custom',
    width: 130
  },
  {
    prop: 'planEndTime',
    label: '预计结束时间',
    sortable: 'custom',
    width: 130
  },
  // {prop:'status',label:'需求状态',sortable:true},
  {
    prop: 'changeFlag',
    label: '变更标志',
    sortable: 'custom',
    formatter: row => {
      return row === 1 ? '原始' : (row === 2 ? '变更' : '暂无信息')
    }
  },
  {
    prop: 'demandJobStatus',
    label: '工作状态',
    width: 100
  }
]

export const meetingRecords = [{
  prop: 'type',
  label: '会议类型',
  formatter: row => {
    return row === 1 ? '售前会议' : (row === 2 ? '项目会议' : '暂无信息')
  }
},
  {
    prop: 'hostList',
    label: '会议主持',
    formatter: row => {
      return row.map(item => item).join(',')
    }
  },
  {
    prop: 'topic',
    label: '会议主题'
  },
  {
    prop: 'projectVO',
    label: '所属项目'
  },
  {
    prop: 'startTime',
    label: '会议时间',
    width: 300
  },
  {
    prop: 'endTime',
    label: '会议时长'
  },
  {
    prop: 'place',
    label: '会议地点'
  },
  {
    prop: 'content',
    label: '会议记录'
  }
]

export const fileName = [{
  prop: 'fileInfoVO',
  label: '名称'
},
  {
    prop: 'fileType',
    label: '文档类别'
  },
  {
    prop: 'createName',
    label: '创建人'
  },
  {
    prop: 'createTime',
    label: '上传时间'
  }
]

export const otherServiceName = [{
  prop: 'type',
  label: '账号类型'
},
  {
    prop: 'account',
    label: '账号'
  },
  {
    prop: 'password',
    label: '密码'
  },
  {
    prop: 'introduction',
    label: '使用情况'
  },
  {
    prop: 'expireTime',
    label: '到期时间'
  },
  {
    prop: 'balance',
    label: '账户余额',
    formatter: row => {
      return row ? '￥' + Number(row).toFixed(2) : '--'
    }
  },
  {
    prop: 'updateTime',
    label: '更新时间'
  },
  {
    prop: 'updateBy',
    label: '更新人'
  },
  {
    prop: 'remark',
    label: '备注信息'
  }
]

export const memberName = [{
  prop: 'employeeName',
  label: '用户'
},
  {
    prop: 'jobName',
    label: '岗位'
  },
  {
    prop: 'jobRankName',
    label: '等级'
  },
  {
    prop: 'intimacy',
    label: '专职/兼职',
    width: 100,
    formatter: row => {
      return row === 1 ? '专职' : (row === 2 ? '兼职' : '暂无信息')
    }
  },
  {
    prop: 'fulltimeProjects',
    label: '专职项目'
  },
  {
    prop: 'parttimeProjects',
    label: '兼职项目'
  },
  {
    prop: 'projectRoleVOList',
    label: '项目角色',
    width: 145
  },
  {
    prop: 'firstJoinTime',
    label: '加入时间'
  },
  {
    prop: 'leaveTime',
    label: '离开时间'
  },
  {
    prop: 'recentJoinTime',
    label: '最近加入时间'
  },
  {
    prop: 'handoverName',
    label: '交接人'
  },
  {
    prop: 'handover',
    label: '交接文件',
    width: 100
  },
  {
    prop: 'status',
    label: '目前状态'
  }
]

export const personRecord = [{
  prop: 'fileInfoVO',
  label: '文件名'
},
  {
    prop: 'month',
    label: '实际上传月份'
  },
  {
    prop: 'createTime',
    label: '上传时间'
  },
  {
    prop: 'createByName',
    label: '处理人'
  }
]

// export const defaulutDetail = [
//   {prop:'fileInfoVO',label:'时间'},
//   {prop:'time',label:'消耗类型'},
//   {prop:'createTime',label:'项目及版本'},
//   {prop:'createName',label:'项目阶段'},
//   {prop:'createName',label:'会议主题'},
//   {prop:'createName',label:'任务类型'},
//   {prop:'createName',label:'人员'},
//   {prop:'createName',label:'消耗资源（人天）',width:'150'},
//   {prop:'createName',label:'资源消耗（与系数相关）',width:'180'}
// ]

// export const meetingDetail = [
//   {prop:'fileInfoVO',label:'时间'},
//   {prop:'time',label:'消耗类型'},
//   {prop:'createTime',label:'项目及版本'},
//   {prop:'createName',label:'项目阶段'},
//   {prop:'createName',label:'会议主题'},
//   {prop:'createName',label:'人员'},
//   {prop:'createName',label:'消耗资源（人天）',width:'150'},
//   {prop:'createName',label:'资源消耗（与系数相关）',width:'180'}
// ]

export const projectDetail = [{
  prop: 'statisticsTime',
  label: '时间'
},
  {
    prop: 'type',
    label: '消耗类型'
  },
  {
    prop: 'projectName',
    label: '项目及版本'
  },
  {
    prop: 'employeeName',
    label: '人员'
  },
  {
    prop: 'originalConversionTime',
    label: '消耗资源（人天）'
  },
  {
    prop: 'actualConversionTime',
    label: '消耗资源（含能力系数）'
  }
]

// export const noMeetingDetail = [
//   {prop:'fileInfoVO',label:'时间'},
//   {prop:'time',label:'消耗类型'},
//   {prop:'createName',label:'会议主题'},
//   {prop:'createName',label:'人员'},
//   {prop:'createName',label:'消耗资源（人天）',width:'150'},
//   {prop:'createName',label:'资源消耗（与系数相关）',width:'180'}
// ]

// export const missionDetail = [
//   {prop:'fileInfoVO',label:'时间'},
//   {prop:'time',label:'消耗类型'},
//   {prop:'createName',label:'任务类型'},
//   {prop:'createName',label:'人员'},
//   {prop:'createName',label:'消耗资源（人天）',width:'150'},
//   {prop:'createName',label:'资源消耗（与系数相关）',width:'180'}
// ]



// WEBPACK FOOTER //
// ./src/utils/tableColumn.js